import { throttle } from 'lodash-es'
import { useEffect, useState } from 'react'

// ref: https://tailwindcss.com/docs/responsive-design
const defaultScreens = {
  'sm': 640,
  'md': 768,
  'lg': 1024,
  'xl': 1280,
  '2xl': 1536,
  '3xl': 1920,
  '4xl': 2560,
}

/**
 * 基于 tailwind screens 检查断点
 *
 * 通常不建议通过 JS 处理屏幕断点逻辑，应尽量通过 CSS 处理，
 * 目前来看可使用的场景有：
 *
 * - 不同断点间的 UI 差异巨大，避免执行无效的 JS 逻辑
 */
export function useScreenMatched(type: keyof typeof defaultScreens) {
  const [matched, setMatched] = useState(false)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const run = throttle(() => {
      const width = window.innerWidth
      if (width >= defaultScreens[type]) {
        setMatched(true)
      } else {
        setMatched(false)
      }
      setReady(true)
    }, 240)

    window.addEventListener('resize', run)

    run()
    return () => {
      window.removeEventListener('resize', run)
    }
  }, [type])

  return { matched, ready }
}

export function useScreen(type: keyof typeof defaultScreens) {
  const { matched } = useScreenMatched(type)
  return matched
}
